/* LYVEA Rotterdam – eigen reviewsectie (geen Judge.me) */
(function () {
  'use strict';

  var STAR_PATH = 'M12 2.6l2.82 6.2 6.78.73-5.06 4.57 1.42 6.67L12 17.4l-5.96 3.37 1.42-6.67L2.4 9.53l6.78-.73z';
  var autoplayTimers = [];

  function readData(source) {
    var el = source && source.querySelector('[data-lyvea-reviews-data]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function fmt(n) { return (Math.round(n * 10) / 10).toFixed(1).replace('.', ','); }

  function verdict(n) {
    n = Math.round(n * 10) / 10;
    if (n >= 4.5) return 'Uitstekend';
    if (n >= 4) return 'Zeer goed';
    if (n >= 3) return 'Goed';
    if (n >= 2) return 'Matig';
    return 'Slecht';
  }

  function starsHTML(rating, size) {
    var html = '<span class="lyv-stars lyv-stars--' + size + '" role="img" aria-label="' + fmt(rating) + ' van 5 sterren">';
    for (var i = 0; i < 5; i++) {
      var fill = Math.max(0, Math.min(100, Math.round((rating - i) * 100)));
      html += '<span class="lyv-star" style="--lyv-fill:' + fill + '%" aria-hidden="true"><svg viewBox="0 0 24 24" focusable="false"><path d="' + STAR_PATH + '"/></svg></span>';
    }
    return html + '</span>';
  }

  function findMainProductSection() {
    var candidates = [
      'product-info', '[data-section-type="product"]', '[data-product-form]',
      'form[action*="/cart/add"]', '.product-single', '.product'
    ];
    for (var i = 0; i < candidates.length; i++) {
      var el = document.querySelector(candidates[i]);
      if (el) {
        var sec = el.closest('.shopify-section');
        if (sec && !sec.closest('.shopify-section-group-header-group, .shopify-section-group-footer-group')) return sec;
      }
    }
    var main = document.querySelector('main .shopify-section[id*="__main"], main .shopify-section');
    return main || null;
  }

  function findProductTitle(scope) {
    var root = scope || document;
    var el = root.querySelector('.kr-product-title, .product__title h1, .product__title, .product-single__title, .product-title, .product__heading, h1');
    if (!el) return null;
    var wrap = el.closest('.product__title');
    return wrap || el;
  }

  /* ---------- Carrousel: één kaart tegelijk met ronde pijltjes + puntjes ---------- */
  function initCarousel(widget, data) {
    var track = widget.querySelector('[data-lyvea-track]');
    if (!track) return;
    var cards = track.children;
    var prev = widget.querySelector('[data-lyvea-prev]');
    var next = widget.querySelector('[data-lyvea-next]');

    function index() {
      var w = track.clientWidth || 1;
      return Math.max(0, Math.min(cards.length - 1, Math.round(track.scrollLeft / w)));
    }
    function goTo(i) {
      var n = cards.length;
      if (!n) return;
      i = ((i % n) + n) % n; // na de laatste weer naar de eerste
      track.scrollTo({ left: cards[i].offsetLeft - track.firstElementChild.offsetLeft, behavior: 'smooth' });
    }

    // Navigatiepuntjes (naast de ronde pijltjes)
    var dotsWrap = widget.querySelector('[data-lyvea-dots]');
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var d = 0; d < cards.length; d++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'lyv-rev__dot';
        b.setAttribute('aria-label', 'Toon review ' + (d + 1) + ' van ' + cards.length);
        b.dataset.index = d;
        b.addEventListener('click', function (e) { goTo(+e.currentTarget.dataset.index); stopAutoplay(); });
        dotsWrap.appendChild(b);
      }
    }
    function updateDots() {
      if (!dotsWrap) return;
      var i = index();
      for (var k = 0; k < dotsWrap.children.length; k++) dotsWrap.children[k].setAttribute('aria-current', k === i ? 'true' : 'false');
    }
    var raf;
    track.addEventListener('scroll', function () { cancelAnimationFrame(raf); raf = requestAnimationFrame(updateDots); }, { passive: true });
    updateDots();

    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); stopAutoplay(); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); stopAutoplay(); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(index() - 1); stopAutoplay(); }
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(index() + 1); stopAutoplay(); }
    });

    var timer = null;
    function stopAutoplay() { if (timer) { clearInterval(timer); timer = null; } }
    if (data && data.autoplay && cards.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      timer = setInterval(function () { goTo(index() + 1); }, 7000);
      autoplayTimers.push(timer);
      ['pointerdown', 'mouseenter', 'focusin', 'touchstart'].forEach(function (ev) {
        widget.addEventListener(ev, stopAutoplay, { passive: true });
      });
    }

    widget.addEventListener('shopify:block:select', function (e) {
      var card = e.target.closest ? e.target.closest('.lyv-card') : null;
      if (card) track.scrollTo({ left: card.offsetLeft - track.firstElementChild.offsetLeft, behavior: 'smooth' });
    });
  }

  /* ---------- Sterrenbalk per product ---------- */
  function initStarBars(data, isProduct) {
    if (!data) return;
    var bars = Array.prototype.slice.call(document.querySelectorAll('[data-lyvea-star-bar]'));

    if (isProduct && data.autoStarBar && bars.length === 0 && data.productId) {
      var title = findProductTitle(findMainProductSection());
      if (title) {
        var auto = document.createElement('div');
        auto.className = 'lyv-bar';
        auto.setAttribute('data-lyvea-star-bar', '');
        auto.setAttribute('data-lyvea-auto', '');
        auto.dataset.productId = data.productId;
        auto.hidden = true;
        title.insertAdjacentElement('beforebegin', auto); // boven de producttitel
        bars.push(auto);
      }
    }

    // Homepage: dezelfde winkelbrede sterrenbalk, gecentreerd direct onder de openingsbanner
    if (data.template === 'index') {
      var firstSection = document.querySelector('#MainContent > .shopify-section, main > .shopify-section');
      if (firstSection) {
        var home = document.createElement('div');
        home.className = 'lyv-bar lyv-bar--home';
        home.setAttribute('data-lyvea-star-bar', '');
        home.setAttribute('data-lyvea-auto', '');
        home.dataset.productId = 'home';
        home.hidden = true;
        firstSection.insertAdjacentElement('afterend', home);
        bars.push(home);
      }
    }

    // Sterrenbalk altijd BOVEN de producttitel plaatsen (alle productsjablonen)
    if (isProduct) {
      bars.forEach(function (bar) {
        var title = findProductTitle(bar.closest('.shopify-section') || findMainProductSection());
        if (title && title !== bar && !title.contains(bar) &&
            (title.compareDocumentPosition(bar) & Node.DOCUMENT_POSITION_FOLLOWING)) {
          title.parentNode.insertBefore(bar, title);
        }
      });
    }

    var seenProducts = {};
    bars.forEach(function (bar) {
      var pid = bar.dataset.productId;
      if (seenProducts[pid]) { bar.remove(); return; }
      seenProducts[pid] = true;

      var avg = 0, count = 0, sum = 0;
      if (data.demo) {
        // Ontwerp-preview: voorbeeldbalk (4,7 / 600), duidelijk gemarkeerd. Nooit op het live thema;
        // live worden altijd alleen de echte, gepubliceerde reviews geteld.
        avg = 4.7; count = 600;
      } else {
        // Live: winkelbreed gemiddelde en totaal aantal echte, gepubliceerde reviews
        (data.reviews || []).forEach(function (r) {
          if (typeof r.r === 'number') { sum += r.r; count++; }
        });
        if (count) avg = sum / count;
      }
      if (!count) { bar.hidden = true; bar.innerHTML = ''; return; }

      bar.innerHTML =
        starsHTML(avg, 'bar') +
        '<span class="lyv-bar__score">' + fmt(avg) + '/5 ' + verdict(avg) + '</span>' +
        '<span class="lyv-bar__count">(' + count + '<span class="lyv-bar__word"> ' + (count === 1 ? 'beoordeling' : 'beoordelingen') + '</span>)</span>' +
        (data.demo ? '<span class="lyv-bar__demo">Voorbeeld</span>' : '');
      bar.setAttribute('role', 'link');
      bar.setAttribute('tabindex', '0');
      bar.setAttribute('aria-label', fmt(avg) + ' van 5 sterren, ' + count + ' beoordelingen – naar de reviews');
      bar.hidden = false;
      var go = function () {
        var target = document.getElementById('lyvea-reviews');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      };
      bar.onclick = go;
      bar.onkeydown = function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } };
    });
  }

  /* ---------- Hoofdinit ---------- */
  function init() {
    autoplayTimers.forEach(clearInterval); autoplayTimers = [];

    var source = document.querySelector('[data-lyvea-reviews-source]');
    var data = readData(source);
    var isProduct = data && data.template === 'product';

    document.querySelectorAll('[data-lyvea-reviews-moved]').forEach(function (el) { el.remove(); });
    document.querySelectorAll('[data-lyvea-auto-mount]').forEach(function (el) { el.remove(); });
    document.querySelectorAll('.lyv-bar[data-lyvea-auto]').forEach(function (el) { el.remove(); });

    var widget = source && source.querySelector('[data-lyvea-reviews]');
    var mounts = Array.prototype.slice.call(document.querySelectorAll('[data-lyvea-reviews-mount]'));

    if (widget) {
      var mount = mounts[0] || null;
      if (!mount && isProduct && data.autoProduct) {
        var main = findMainProductSection();
        if (main) {
          mount = document.createElement('div');
          mount.className = 'lyv-mount';
          mount.setAttribute('data-lyvea-auto-mount', '');
          main.insertAdjacentElement('afterend', mount);
        }
      }
      if (mount) {
        widget.setAttribute('data-lyvea-reviews-moved', '');
        mount.innerHTML = '';
        mount.appendChild(widget);
        initCarousel(widget, data);
      }
    }

    mounts.forEach(function (m) {
      var sec = m.closest('.shopify-section');
      if (sec) sec.style.display = m.children.length ? '' : 'none';
    });

    initStarBars(data, isProduct);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { setTimeout(init, 0); });
})();
